// using webpack and env?
// export const API_ROOT_URL = process.env.REACT_APP_API_ROOT_URL || 'https://federation.forusapi.com'
// export const API_ROOT_URL = 'https://vision.pellar.io'
export const API_ROOT_URL = process.env.REACT_APP_API_ROOT_URL || 'https://federation.forusapi.com'
export const AVATAR_BASEURL = process.env.REACT_APP_AVATAR_BASEURL // 'https://s3-ap-southeast-1.amazonaws.com/xiffiles.pellar.io/avatars/'
//export const AVATAR_BASEURL = 'https://s3-ap-southeast-1.amazonaws.com/visionasset/avatars/'
export const PAGESIZE = 50
export const COIN_MASTER_ADDRESS = process.env.REACT_APP_COIN_MASTER_ADDRESS //'024ea4abd05b5d3a6ab3a877e1943c94ba71487dee1eea1a96b952b3ff99486bc7'
export const BASE_COIN_SYMBOLS = process.env.REACT_APP_BASE_COIN_SYMBOLS // 'XIF,XIP'
export const BASE_COIN_SYMBOL = process.env.REACT_APP_BASE_COIN_SYMBOL || 'MHX'
export const NODE_ENV = process.env.NODE_ENV
export const REACT_APP_ENABLE_MERCHANT_FUNCTIONS = process.env.REACT_APP_ENABLE_MERCHANT_FUNCTIONS || false
export const REACT_APP_ENABLE_GEMINI_FUNCTIONS = process.env.REACT_APP_ENABLE_GEMINI_FUNCTIONS || false
export const REACT_APP_ENABLE_RATES_FUNCTIONS = process.env.REACT_APP_ENABLE_RATES_FUNCTIONS || false
export const REACT_APP_DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL || 'http://localhost:3005'

export const TOKEN_STATUS = {
    pending: 'PENDING',
    approved: 'APPROVED',
    progressing_accounts: 'PROCESSING_ACCOUNTS',
    complete_accounts: 'COMPLETE_ACCOUNT',
    progressing_contacts: 'PROCESSING_CONTACTS',
    complete: 'COMPLETE',
    rejected: 'REJECTED',
    paused: 'PAUSED'
}

export const Countries = [
    { name: 'Bahamas', account_name: 'Bahamian Dollar', symbol: 'BSD', iso2: 'bs', currency: "BSD", dialCode: '1242' },
    { name: 'Cambodia', account_name: 'Cambodian Riel', symbol: 'KHR', iso2: 'kh', currency: "KHR", dialCode: '855' },
    { name: 'Curacao (Netherlands)', account_name: 'Netherlands Antillean Guilder', symbol: 'ANG', iso2: 'cw', currency: "ANG", dialCode: '5999' },
    { name: 'Ethiopia', account_name: 'Ethiopian Birr', symbol: 'ETB', iso2: 'et', currency: "ETB", dialCode: '251' },
    { name: 'Ireland', account_name: 'European Euro', symbol: 'EUR', iso2: 'ie', currency: "EUR", dialCode: '353' },
    { name: 'Lesotho', account_name: 'Lesotho Loti', symbol: 'LSL', iso2: 'ls', currency: "LSL", dialCode: '266' },
    { name: 'Maldives', account_name: 'Maldivian Rufiyaa', symbol: 'MVR', iso2: 'mv', currency: "MVR", dialCode: '960' },
    { name: 'Nigeria', account_name: 'Nigerian Naira', symbol: 'NGN', iso2: 'ng', currency: "NGN", dialCode: '234' },
    { name: 'Oman', account_name: 'Omani Rial', symbol: 'OMR', iso2: 'om', currency: "OMR", dialCode: '968' },
    { name: 'Sint Maarten (Netherlands)', account_name: 'United States Dollar', symbol: 'USD', iso2: 'sx', currency: "USD", dialCode: '1721' },
    { name: 'South Africa', account_name: 'South African Rand', symbol: 'ZAR', iso2: 'za', currency: "ZAR", dialCode: '27' },
    { name: 'Sri Lanka', account_name: 'Sri Lankan Rupee', symbol: 'LKR', iso2: 'lk', currency: "LKR", dialCode: '94' },
    { name: 'Thailand', account_name: 'Thai Baht', symbol: 'THB', iso2: 'th', currency: "THB", dialCode: '66' },
    { name: 'United States of America', account_name: 'United States Dollar', symbol: 'USD', iso2: 'us', currency: "USD", dialCode: '1' },
    { name: 'Vietnam', account_name: 'Vietnamese Dong', symbol: 'VND', iso2: 'vn', currency: "VND", dialCode: '84' },
    { name: 'New Zealand', account_name: 'New Zealand Dollar', symbol: 'NZD', iso2: 'nz', currency: "NZD", dialCode: '64' },
    { name: 'Australia', account_name: 'Australian Dollar', symbol: 'AUD', iso2: 'au', currency: "AUD", dialCode: '61' },
    { name: 'Canada', account_name: 'Canadian Dollar', symbol: 'CAD', iso2: 'ca', currency: "CAD", dialCode: '1' },
]



// WEBPACK FOOTER //
// ./src/constants/config.js